<script setup lang="ts">
import { alphabetToPref } from "~~/utils/sekou/area";

const props = defineProps<{ pref: string; city: string; off: string }>();

const prefKanji = alphabetToPref(props.pref);
</script>

<template>
  <SekouListArea :pref="prefKanji" :city="city" :off="off" />
</template>
